import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, unref as _unref, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) { return (_pushScopeId("data-v-3cfd353e"), n = n(), _popScopeId(), n); };
var _hoisted_1 = {
    class: "px-4 py-2 bg-white rounded-lg mb-4 dark:bg-gray-800",
    style: { "width": "80%" }
};
import { useRoute } from 'vue-router';
import { patientStore } from '@/store/patient';
import { storeToRefs } from 'pinia';
import AlertModal from "@/components/AlertModalFeedback.vue";
import { ref } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'FamiliareSection',
    emits: ["save", "edit_fisiologica"],
    setup: function (__props, _a) {
        var emit = _a.emit;
        var Route = useRoute();
        var alertModal = ref(null);
        var showLoading = ref(false);
        var store = patientStore();
        var patient = storeToRefs(store).patient;
        function SaveAnamnesi() {
            showLoading.value = true;
            store.savePaziente("AnamnesiFamiliare", patient.value.id_paziente).then(function (response) {
                showLoading.value = false;
                alertModal.value.openModal("Dati salvati con successo!", false);
            }, function (error) {
                console.log(error);
                alertModal.value.openModal("Siamo spiacenti si è verificato un errore. La preghiamo di riprovare più tardi", false);
            });
        }
        return function (_ctx, _cache) {
            var _component_LoadingComponent = _resolveComponent("LoadingComponent");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(AlertModal, {
                    ref_key: "alertModal",
                    ref: alertModal
                }, null, 512),
                _createElementVNode("div", _hoisted_1, [
                    _withDirectives(_createElementVNode("textarea", {
                        id: "textFamiliare",
                        ref: "textArea",
                        rows: "10",
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) { return ((_unref(patient).tbl_anamnesi_familiare.anamnesi_familiare_contenuto) = $event); }),
                        class: "textStyle w-full px-0 bg-white border-0 dark:bg-gray-800 focus:ring-0 dark:text-white dark:placeholder-gray-400",
                        placeholder: "",
                        required: ""
                    }, "\n      ", 512), [
                        [_vModelText, _unref(patient).tbl_anamnesi_familiare.anamnesi_familiare_contenuto]
                    ])
                ]),
                (showLoading.value)
                    ? (_openBlock(), _createBlock(_component_LoadingComponent, { key: 0 }))
                    : _createCommentVNode("", true),
                _createElementVNode("button", {
                    id: "submitFamiliare",
                    ref: "salvaBtn",
                    type: "button",
                    onClick: SaveAnamnesi,
                    style: { "background-color": "#1A576E" },
                    class: "mt-2 py-2.5 px-4 text-base font-medium text-center text-white rounded-lg focus:ring-4 focus:ring-blue-200 dark:focus:ring-blue-900 hover:bg-blue-800"
                }, _toDisplayString(_ctx.$t("Salva")), 513)
            ], 64));
        };
    }
});
